/* eslint-disable react/jsx-filename-extension */
import { createRoot } from 'react-dom/client';
import App from './App.jsx';

const el = document.querySelector('#app');
const root = createRoot(el);
root.render(
  <App />,
);
